/**
 * Give focus to a provided element with an id if it isn't already the current element with focus
 * @param {Element} elementWithId an HTML Element often provided by a callback Ref with a valid `id` attribute
 */
export function focusOnFirstComponent(elementWithId) {
  // if the current focussed ("active") element's id !== elementWithId.id
  if (
    document.activeElement &&
    elementWithId &&
    document.activeElement.id !== elementWithId.id
  ) {
    // give focus to the element passed as a parameter
    elementWithId.focus();
  }
}
